// Static imports for rent app ICON SVGs only (not larger assets like gift card thumbnails)
import iconBoxAlert from '~images/svgs/icon__box--alert.svg?inline';
import iconBoxAtHome from '~images/svgs/icon__box--at-home.svg?inline';
import iconBoxBonusItemsDesktop from '~images/svgs/icon__box--bonus-items-desktop.svg?inline';
import iconBoxBonusItemsMobile from '~images/svgs/icon__box--bonus-items-mobile.svg?inline';
import iconBoxClosed from '~images/svgs/icon__box--closed.svg?inline';
import iconBoxEarlyReturn from '~images/svgs/icon__box--early-return.svg?inline';
import iconBoxInTransit from '~images/svgs/icon__box--in-transit.svg?inline';
import iconBoxOpen from '~images/svgs/icon__box--open.svg?inline';
import iconBoxPacked from '~images/svgs/icon__box--packed.svg?inline';
import iconBoxPaused from '~images/svgs/icon__box--paused.svg?inline';
import iconBoxPendingMessage from '~images/svgs/icon__box--pending-message.svg?inline';
import iconBoxRequested from '~images/svgs/icon__box--requested.svg?inline';
import iconCatalogFourUp from '~images/svgs/icon__catalog--four-up.svg?inline';
import iconCatalogOneUp from '~images/svgs/icon__catalog--one-up.svg?inline';
import iconCatalogSize from '~images/svgs/icon__catalog--size.svg?inline';
import iconCatalogTwoUp from '~images/svgs/icon__catalog--two-up.svg?inline';
import iconGiftCardsGift from '~images/svgs/icon__giftCards--gift.svg?inline';
import iconRewardsBonusItem from '~images/svgs/icon__rewards--bonus-item.svg?inline';
import iconRewardsItemPurchase from '~images/svgs/icon__rewards--item-purchase.svg?inline';
import iconRewardsSubscription from '~images/svgs/icon__rewards--subscription.svg?inline';
import iconStepperCheckmark from '~images/svgs/icon__stepper--checkmark.svg?inline';

import { GLOBAL_ICONS } from '~coreModules/core/js/icon-constants.js';

export const APP_ICON_REGISTRY = {
    'icon__box--alert.svg': iconBoxAlert,
    'icon__box--at-home.svg': iconBoxAtHome,
    'icon__box--bonus-items-desktop.svg': iconBoxBonusItemsDesktop,
    'icon__box--bonus-items-mobile.svg': iconBoxBonusItemsMobile,
    'icon__box--closed.svg': iconBoxClosed,
    'icon__box--early-return.svg': iconBoxEarlyReturn,
    'icon__box--in-transit.svg': iconBoxInTransit,
    'icon__box--open.svg': iconBoxOpen,
    'icon__box--packed.svg': iconBoxPacked,
    'icon__box--paused.svg': iconBoxPaused,
    'icon__box--pending-message.svg': iconBoxPendingMessage,
    'icon__box--requested.svg': iconBoxRequested,
    'icon__catalog--four-up.svg': iconCatalogFourUp,
    'icon__catalog--one-up.svg': iconCatalogOneUp,
    'icon__catalog--size.svg': iconCatalogSize,
    'icon__catalog--two-up.svg': iconCatalogTwoUp,
    'icon__giftCards--gift.svg': iconGiftCardsGift,
    'icon__rewards--bonus-item.svg': iconRewardsBonusItem,
    'icon__rewards--item-purchase.svg': iconRewardsItemPurchase,
    'icon__rewards--subscription.svg': iconRewardsSubscription,
    'icon__stepper--checkmark.svg': iconStepperCheckmark,
};

const APP_ICON_DATA = new Map([
    ['box--alert', { altText: 'alert box icon', svgContent: iconBoxAlert }],
    ['box--at-home', { altText: 'box at home icon', svgContent: iconBoxAtHome }],
    ['box--bonus-items-desktop', { altText: 'bonus items icon', svgContent: iconBoxBonusItemsDesktop }],
    ['box--bonus-items-mobile', { altText: 'bonus items icon', svgContent: iconBoxBonusItemsMobile }],
    ['box--closed', { altText: 'closed box icon', svgContent: iconBoxClosed }],
    ['box--early-return', { altText: 'early return box icon', svgContent: iconBoxEarlyReturn }],
    ['box--in-transit', { altText: 'box in transit icon', svgContent: iconBoxInTransit }],
    ['box--open', { altText: 'open box icon', svgContent: iconBoxOpen }],
    ['box--packed', { altText: 'packed box icon', svgContent: iconBoxPacked }],
    ['box--paused', { altText: 'paused box icon', svgContent: iconBoxPaused }],
    ['box--pending-message', { altText: 'pending message box icon', svgContent: iconBoxPendingMessage }],
    ['box--requested', { altText: 'requested box icon', svgContent: iconBoxRequested }],
    ['catalog--four-up', { altText: 'four column view icon', svgContent: iconCatalogFourUp }],
    ['catalog--one-up', { altText: 'single column view icon', svgContent: iconCatalogOneUp }],
    ['catalog--size', { altText: 'size icon', svgContent: iconCatalogSize }],
    ['catalog--two-up', { altText: 'two column view icon', svgContent: iconCatalogTwoUp }],
    ['giftCards--gift', { altText: 'gift icon', svgContent: iconGiftCardsGift }],
    ['rewards--bonus-item', { altText: 'bonus item reward icon', svgContent: iconRewardsBonusItem }],
    ['rewards--item-purchase', { altText: 'item purchase reward icon', svgContent: iconRewardsItemPurchase }],
    ['rewards--subscription', { altText: 'subscription reward icon', svgContent: iconRewardsSubscription }],
    ['stepper--checkmark', { altText: 'stepper checkmark icon', svgContent: iconStepperCheckmark }],
]);

export const APP_ICONS = new Map([...GLOBAL_ICONS, ...APP_ICON_DATA]);

export default APP_ICONS;
